import React from 'react';
import { Tooltip } from 'react-tooltip';
import { useTranslation } from 'react-i18next';
import Button from '@/shared/components/AppButton'
import { GradientBorder } from '@/shared/components/GradientBorder'
import Microphone from '@/images/microphone.png';
import UpoloadFile from '@/images/upload.png';
import GeneratingIcon from '@/images/generating.gif';

const StartState = ({ 
  mode, // 'record' or 'upload'
  disabled, 
  isDisabled,
  onStart,
  uploadModelOpen,
  nonAudioTool,
  onBrowseClick
}) => {
  const { t } = useTranslation();

  const getIcon = () => {
    if (mode === 'record') {
      return <img width={'24px'} src={Microphone} alt='recording mic' />;
    }
    if (uploadModelOpen) {
      return <img width={'24px'} src={GeneratingIcon} alt='uploading' loading='eager' />;
    }
    return <img width={'24px'} src={UpoloadFile} alt='upload file' />;
  };

  const getTitle = () => {
    if (mode === 'record') {
      return t('reports.generate.record.title');
    }
    if (uploadModelOpen) {
      return t('reports.generate.file.selecting');
    }
    return t('reports.generate.file.choose');
  };

  const getDescription = () => {
    if (mode === 'record') {
      return t('reports.generate.record.info');
    }
    if (uploadModelOpen) {
      return t('reports.generate.pleaseWait');
    }
    return nonAudioTool ? t('reports.generate.file.formatsPdf') : t('reports.generate.file.formats');
  };

  const getButtonText = () => {
    if (mode === 'record') {
      return t('reports.generate.record.start');
    }
    return t('reports.generate.file.browse');
  };

  return (
    <>
      {isDisabled.noWords && <Tooltip id="no-words" place="bottom"/>}
      <div className={`flex flex-col justify-center items-center text-center w-full`}>
        <GradientBorder>
          <div className="shadow-sm bg-white rounded-full px-4 py-4">
            {getIcon()}
          </div>
        </GradientBorder>
        <h1 className='font-medium mt-[16px] md:text-[24px] text-xl'>
          {getTitle()}
        </h1>
        <p className='mt-[4px] text-[#505050] text-[16px] font-SuisseIntlLight font-normal'>
          {getDescription()}
        </p>
        <div 
          className='mt-[16px]' 
          onClick={disabled ? undefined : (mode === 'upload' && onBrowseClick ? onBrowseClick : onStart)}
          data-tooltip-id='no-words' 
          data-tooltip-content={mode === 'record' 
            ? t('reports.generate.record.disabledMessage') 
            : 'No more words left. Please contact MPAssist.'
          }
        >
          <Button className={`${disabled && 'cursor-default opacity-80'}`}>
            {getButtonText()}
          </Button>
        </div>
      </div>
    </>
  );
};

export default StartState;